<template>
  <div id="app">
    <router-view class="route"/>
  </div>
</template>

<script>

export default {
  name: 'home',
  components: {}
};
</script>
